import { Col, Form, Select } from "antd";
import { useEffect, useRef, useState } from "react";
import { EXISTING_PO_MAP_LIST } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "utils/functions";

const PackingReportFilterFields = ({ initialTableData }) => {
  // States
  const [poList, setPoList] = useState(null);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  // Antd
  const { Option } = Select;
  const form = Form.useFormInstance();

  const mountedRef = useRef(true);
  const reqIdRef = useRef(0);
  const didSeedDefaultRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const getPOList = async (value = null) => {
    const myReq = ++reqIdRef.current;
    let query = `${EXISTING_PO_MAP_LIST}`;
    if (value) {
      query = `${query}?po_map_id=${value}`;
    }
    const response = await getData(query);

    if (!mountedRef.current || myReq !== reqIdRef.current) return;

    if (response && response?.data?.code === 200) {
      setPoList(response?.data?.data);
    }
    setHasLoadedOnce(true);
  };

  useEffect(() => {
    getPOList();
  }, []);

  // Round 2 (B, R3): PackingListController@existPoList now returns this list ordered
  // by purchase_order_maps.updated_at desc, so the first row is the most recently
  // updated PO with packing requirements — pre-select it. This page's own submit
  // handler (exportPacking) generates a new file on the server on every call, so it
  // is intentionally not auto-triggered on mount here (only the visible default
  // changes; the manual Export/Generate action is unchanged).
  useEffect(() => {
    if (didSeedDefaultRef.current) return;
    if (!hasLoadedOnce) return;
    didSeedDefaultRef.current = true;
    if (!isArrayAndHasValue(poList)) return;

    const mostRecent = poList[0];
    if (!mostRecent?.id) return;

    form?.setFieldsValue({ po_map_id: mostRecent.id });
  }, [hasLoadedOnce, poList, form]);

  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Original PO"
          name="po_map_id"
          rules={[
            {
              required: true,
              message: "Original PO is required",
            },
          ]}
        >
          <Select
            showSearch
            style={{
              width: "100%",
            }}
            placeholder="Search to Select"
            optionFilterProp="children"
            size="small"
            onSearch={getPOList}
            notFoundContent={
              hasLoadedOnce ? "No purchase orders with packing requirements found." : undefined
            }
          >
            {poList &&
              poList?.map((po, idx) => (
                <Option key={idx} value={po?.id}>
                  {po?.original_po}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default PackingReportFilterFields;
